// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3yzPt","checkbox":"styles_checkbox__SsBEu","terms":"styles_terms__4eDgT"};